// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2oJAJ","errors":"Errors_errors__1b5kn"};